import { ChevronLeft, Edit } from 'react-feather';
import {useUser} from "../../lib/useUser";
import { UserMenuNNHeader } from './UserMenuNNHeader';

interface UserMenuEditPersonalDataProps {
  onBack: () => void
}

const UserMenuEditPersonalData = ({onBack}: UserMenuEditPersonalDataProps) => {
  const [user] = useUser()

  return (
    <div className="fav">
      <UserMenuNNHeader
        title="Persönliche Daten"
        onBack={() => onBack()}
        BackIcon={ChevronLeft}
      />
      <div className="user-menu-fav__wrapper">
        <ul className="user-menu-fav__list">
          <li className="user-menu-fav__list-item">
            {user.userName && <>{user?.userName} {user?.userSurname}</>}
            {!user.userName && <>Nutzername nicht gesetzt</> }
            <div className="user-menu-fav__list-item__icons">
              <a
                href={`${process.env.NEXT_PUBLIC_USER_SETTINGS_URL}/digital/index.php?page=feUserData&v=${user?.tokenId}`}
                target="_blank"
                rel="noreferrer"
                aria-label="Nutzername bearbeiten"
              >
                <Edit />
              </a>
            </div>
          </li>

          <li className="user-menu-fav__list-item">
            {user.userEmail}
            <div className="user-menu-fav__list-item__icons">
              <a
                href={`${process.env.NEXT_PUBLIC_USER_SETTINGS_URL}/digital/index.php?page=feUserEmail&v=${user?.tokenId}`}
                target="_blank"
                rel="noreferrer"
                aria-label="E-Mail bearbeiten"
              >
                <Edit />
              </a>
            </div>
          </li>

          <li className="w-full mb-4 text-center">
            <a href={`${process.env.NEXT_PUBLIC_USER_SETTINGS_URL}/digital/index.php?page=feUserPass&v=${user?.tokenId}`} target="_blank" rel="noreferrer">
              <a className="btn btn-primary w-full !rounded-xl" aria-label="Passwort ändern">Passwort ändern</a>
            </a>
          </li>

          <li className="w-full text-center">
            <a href={`${process.env.NEXT_PUBLIC_USER_SETTINGS_URL}/digital/index.php?page=feUserDelete&v=${user?.tokenId}`} target="_blank" rel="noreferrer">
              <a className="btn btn-primary w-full !rounded-xl" aria-label="Account löschen">Account löschen</a>
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default UserMenuEditPersonalData